module.exports = __webpack_public_path__ + "/images/logo-fr-smallable.722a43c.png";